$ = window.jQuery;

// cycle the images in the hero
export default (obj, off) => {
	if (obj.length) {
		let i = 0,
			last = obj.length - 1,
			timer = setInterval(() => {
				i = i++ === last ? 0 : i;
				obj.eq(i).prop("checked", true);
			}, 5000);

		// turn off
		off.on("click change", () => clearInterval(timer));
	}
};
